export default {
  tradeInfo: "收益明细",
  tradedInfo: "已销售的",
  totalAmount: "总金额",
  amountUnit: "￥",
  processing: "处理中",
  availableAmout: "可提现金额",
  withdraw: "提现",
  receiveProfits: "领取收益",
  receiveProfitsRule: "规则说明",
  receiveProfitsTip: "为提现数据收益至银行卡，您需要先开通个人账户。",
  withdrawRule: "提现规则",
  availableTip:
    "当可提现金额与总金额不一致时，会有以下两种原因：<br/>（1）可提现金额受到订单审核流程的影响。例如3月8日中午12时将会统一处理3月7日的订单，导致可提现金额只显示3月7日的订单金额总额。审核完成后，可提现金额将同步更新（通常会在下一个工作日完成)；<br/>（2）提现后，可提现金额会立即更新，但总金额会因为平台处理原因将会在一段时间后延迟更新。",
  withdrawTip:
    "1.提现金额将在一个自然日内到账 <br/> 2.单笔提现金额最低不少于5元，最高不超过20000元，无每日限额 <br/> 3.每笔提现需收取1元手续费",
  processingTip:
    "什么是处理中金额？<br/> 数据相关的收益在进入账户时，可能会经历一定的审核流程。审核通过后，这部分金额才可以提现。",
  availableAmount:
    "可为当前数据商品设置专属佣金比例。数据经纪人分享该数据商品的推广链接，若成功促成他人下单，将按 “订单金额 × 该比例” 获得佣金奖励。为保证总成本不超过数据商品售价，设置的推广佣金比例上限=100%-平台抽成比例",
  userWithdrawable: "用户可提现金额：￥{ amount }",
  withdrawFee: "提现手续费",
  withdrawAmountTip: "请输入提现金额:",
  inputing: "请输入",
  withdrawInputErrorTip: "单笔提现不可少于5元，不可大于20000元。",
  withdrawConfirm: "确认提现",
  withdrawSuccess: "您的提现请求已提交，预计在一个自然日内到账。",
  withdrawFail: "提现失败",
  withdrawTime: "提现申请时间",
  tradeNo: "订单编号",
  tradeType: "交易类型",
  tradeAmount: "交易金额",
  receivedAmount: "到账金额",
  tradeStatus: "状态",
  tradeTime: "创建交易时间",
  apiTradeTime: "订单创建时间",
  arriveTime: "到账时间",
  dianshuServiceFee: "典枢服务费",
  dianshuServiceFeeDetail: "￥{fee} (订单金额{amount}%)",
  dianshuImportFee: "推广佣金",
  dianshuImportFeeDetail: "￥{fee} (订单金额{amount}%)",
  tradeStatusDialog: "订单状态",
  payer: "付款买家",
  dataName: "数据名称",
  apiName: "API名称",
  apiCode: "订单编号",
  apiStatus: "订单状态",
  apiUseNum: "调用情况",
  dataBenefit: "数据收益",
  platFormRewards: "平台奖励",
  apiWeekBenefit: "API周收益",
  orderAmount: "订单金额",
  withdrawAmount: "提现金额",
  rewardAmount: "奖励金额",
  tradeDetail: "订单详情",
  openAccount:
    "按照监管机构的规定，您需要提供以下信息以供开通个人账户，只有开通个人账户后才可将数据收益提现。",
  openAccountNotice:
    "1.个人账户开通后才能开始数据交易。2.典枢不会收集您的个人信息。",
  realName: "真实姓名",
  idCard: "身份证号",
  bankCard: "银行卡号",
  phoneNumber: "银行预留手机号",
  afterBaofu: "提供",
  baofu: "宝付网络科技（上海）有限公司",
  baofuLink: "https://www.baofu.com/",
  beforBaofu: "相关支付服务由",
  realNameTip: "请输入真实姓名",
  idCardTip: "请输入正确的身份证号",
  bankCardTip: "请输入正确的银行卡号",
  phoneNumberTip: "请输入正确的银行预留手机号",
  submitUserAuth: "提交信息",
  userAuthSuccess: "个人账户开通成功",
  notice: "提醒",
  reviewing: "您的信息正在审核中",
  openWallet: "打开钱包",
  dataVerificationReport: "数据验证报告申请",
  applyer: "申请人",
  verifyMethod: "验证方法",
  applyTime: "申请时间",
  auditStatus: "审核状态",
  operation: "操作",
  reject: "拒绝",
  agree: "同意",
  agreed: "已同意",
  pending: "待审核",
  allRead: "全部已读",
  myMessage: "我的消息",
  messageContent: "消息内容",
  messageTime: "发送时间",
  delete: "删除",
  confirmDelete: "确定删除此条信息吗？",
  messageDetail: "消息详情",
  chatMessage: "聊天消息：",
  sysstemMeesage: "系统消息：",
  close: "关闭",
  userInfo: "用户信息",
  uploadUserImage: "上传头像",
  uploadUserImageTip: "支持JPG、JPEG、PNG、GIF格式，图片需小于20M",
  save: "保存",
  changeUserImage: "更换头像",
  imageTypeWarning: "支持JPG、JPEG、PNG、GIF格式",
  imageSizeWarning: "图片需小于20M",
  uploadFail: "上传失败",
  uploadSuccess: "上传成功",
  myNickName: "我的昵称",
  changeName: "修改昵称",
  myIntroduction: "卖家介绍",
  addIntroduction: "添加卖家介绍~~",
  editIntroduction: "修改介绍",
  myIntroduction2: "请输入卖家介绍",
  edit2: "编辑介绍",
  noChange: "未进行修改",
  myAppCode: "我的Appcode",
  enterpriseCertification: "企业认证",
  enterpriseCertificationUndo: "您尚未进行企业认证",
  enterpriseCertificationCheck: "您的企业信息正在审核中，请耐心等待。",
  enterpriseCertificationSuccess: "您已完成企业认证，认证企业：",
  enterpriseCertificationFailed: "很抱歉，您的企业认证未通过，您可重新提交。",
  startCertification: "点击此处开始认证",
  reSubmit: "重新提交",
  submit: "提交",
  // 表单相关
  enterpriseBaseInfo: "企业基本信息",
  enterpriseInvoiceInfo: "企业开票信息",

  // 表单字段
  firmName: "企业名称/单位名称",
  legalName: "企业法人姓名",
  businessLicense: "企业营业执照",
  taxId: "纳税人识别号",
  address: "注册地址",
  bankName: "开户银行",
  bankAccount: "银行账号",
  contactPhone: "联系电话",

  // 表单验证提示
  firmNameRequired: "请输入企业名称",
  legalNameRequired: "请输入法人姓名",
  businessLicenseRequired: "请上传营业执照",
  taxIdRequired: "请输入纳税人识别号",
  addressRequired: "请输入注册地址",
  bankNameRequired: "请输入开户银行",
  bankAccountRequired: "请输入银行账号",
  contactPhoneRequired: "请输入联系电话",
  // 上传相关
  uploadBusinessLicense: "上传营业执照",
  imageFormatError: "只能上传 JPG/PNG 格式的图片",
  imageSizeError: "图片大小不能超过 2MB",

  // 提交相关
  submitSuccess: "提交成功",
  submitFailed: "提交失败，请重试",
  nickNameWarning: "输入文案不能为空",
  edit: "编辑",
  saveSuccess: "保存成功",
  saveFail: "保存失败",
  login: "登录",
  myPassword: "授权密码",
  setPassword: "设置密码",
  processed: "已处理",
  reviewUserTips:
    "用户{name}向您申请了以下数据质量验证报告，请您选择将哪些报告发送给申请方",
  applyReportTitle: "数据验证报告申请",
  auditOrdertTitle: "数据购买申请",
  auditOrdertPass:
    '用户"{name}"向您申请购买:"{datasetName}"，您同意后用户"{name}"可以下载并使用此数据。',
  auditOrdertReject:
    '用户"{name}"向您申请购买"{datasetName}"，您拒绝后将结束与用户"{name}"的交易。',
  isPublic: "是否公开",
  password: "密码",
  changePassword: "修改授权密码",
  chooseAssessmentMethod: "选择至少选择一种验证方法",
  allReadSuccess: "已全部标记为已读",
  allReadFail: "全部已读失败，请稍后重试",
  rejected: "已拒绝",
  auditSuccess: "审核已通过！您已成功同意买家查看验证报告的申请。",
  rejectSuccess: "已拒绝该申请",
  auditSuccess2: "审核已通过！您已成功同意买家购买数据的申请",
  auditFail: "此次审核操作失败，请重试",
  idCardLable: "身份证上传",
  idCardFrontTip: "请上传身份证正面照片",
  idCardBackTip: "请上传身份证反面照片",
  idCardTips:
    "请上传身份证图片正、反面照片，单张大小不超过5MB，分辨率建议500*800以上，支持PNG、JPG、JPEG、BMP格式。建议卡片部分占据图片2/3以上。",
  uploadIdCardTipForType: "仅支持PNG、JPG、JPEG、BMP格式",
  uploadIdCardTipForSize: "上传图片不超过5MB",
  protocolTip:
    '<strong style="color: #000000;">点击提交信息</strong>即代表同意',
  protocolTipError: "请勾选协议",
  and: "和",
  userProtocol: "《用户协议》",
  userProtocolLink: "/user-protocol",
  privateProtocol: "《隐私政策》",
  nav: {
    about: "关于典枢",
    data: {
      market: "数据集市",
      publish: "发布数据",
      request: "有求必应",
    },
    support: {
      title: "下载与支持",
      client: "下载客户端",
      docs: "文档",
    },
  },
  privateProtocolLink: "/privacy-policy",
  merchantProtocol: "《平台开户协议》",
  merchantProtocolLink: "/merchant-protocol",
  companyWebsite: "https://yeez.tech",
  split: "、",
  officalPublicAccount: "官方公众号",
  techCommunity: "技术交流群",
  companyName: "北京熠智科技有限公司版权所有",
  icp: "京ICP备20022436号-3",
  edi: "京EDI证京B2-20220639",
  blockIcp: "区块链京网信备 1101082276223860002X号",
  policeIcp: "京公网安备11010802038645号",
  aboutUs: "关于我们",
  contactUs: "联系电话：010-53385803",
  bisnessCooperation: "商业合作：contact{'@'}yeez.tech",
  companyIntro: "公司简介",
  servicePro: "服务协议",
  setAuthorizationPassword: "设置授权密码",
  securityVerificationMessage: "为了该账号的安全，请使用手机完成验证码验证",
  securityVerificationEmailMessage: "为了该账号的安全，请完成邮箱验证",
  phoneNum: "手机号码",
  phoneNumberPlaceholder: "请输入手机号",
  verificationCode: "验证码",
  verificationCodeRequired: "请输入验证码",
  invalidVerificationCode: "验证码格式不正确",
  verificationCodeNotSent: "请先发送验证码",
  email: "邮箱地址",
  emailPlaceholder: "请输入邮箱",
  confirm: "确定",
  cancel: "取消",
  purchaseRequest: "数据购买申请",
  reportAudit: "报告审核",
  tradeAudit: "交易审核",
  buyer: "数据买家",
  purchaseTime: "购买时间",
  auditDeadline: "审核截止时间",
  searchDataOrBuyer: "请输入数据名称或数据买家",
  searchDataOrApplicant: "请输入数据名称或申请人",
  auditTimeLimit:
    "买家付款后的7天内对数据交易进行审核。超过此时间未作出决定，系统将默认视为拒绝交易，款项会自动退还给买家。",
  auditStateDesc: {
    pending: "待审核：未对买家的交易进行审核，交易处于待审核状态。",
    rejected: "已拒绝：主动拒绝交易，买家无法下载数据。",
    approved: "已同意：审核通过，同意交易，买家可以下载数据。",
  },
  auditTimeDesc:
    "审核截止时间是指卖家需要在买家付款后的7天内对数据交易进行审核。超过此时间未作出决定，系统将默认视为拒绝此交易，款项会自动退还给买家。",
  privateKey: {
    welcomeMessage:
      '欢迎加入典枢！为确保您的账户安全，请设置授权密码。该密码将在您进行<strong style="color: #FF9432;">发布数据</strong>或<strong style="color: #FF9432;">购买数据</strong>时使用，感谢您的配合！',
    onlyNumbers: "请输入只包含数字的授权密码",
    changeMessage:
      '请设置新的授权密码，该密码将在您进行<strong style="color: #FF9432;">发布数据</strong>或<strong style="color: #FF9432;">购买数据</strong>时使用，感谢您的配合！',
    sixDigitsRequired: "请输入六位的数字密码",
    setNewPassword: "设置新的授权密码",
    setPassword: "设置密码",
    setPasswordMessage: "您还未设置授权密码，请先设置授权密码。",
    passwordSetSuccess: "设置密码成功",
    confirmPassword: "确认密码",
    enterSixDigitPassword: "请设置一个6位的数字授权密码",
    passwordMismatch: "密码前后不一致",
    enterPassword: "输入授权密码",
    enterPasswordMessage:
      "请输入授权密码，以完成对当前交易信息的签名及加密信息的解密还原。",
    incorrectPassword: "密码错误，请重新输入",
    pleaseEnterPassword: "请输入6位的数字授权密码",
    authPasswordDescription:
      "授权密码是您首次登录典枢时设置的6位数字密码。如您忘记密码，可前往",
    personalInfoLink: "个人信息",
    resetInstructions: "页面进行重置。",
    privateKeyRetrievalFailed: "获取私钥失败",
    passwordSetupFailed: "设置密码失败",
    whatIsAuthPassword: "什么是授权密码？",
    passwordPlaceholder: "请输入 6 位数字授权密码：",
  },
};
